module.exports = __webpack_public_path__ + "static/media/TitleExtensionExample@3x.6668deb05651dcab10aa10b50c1ffbcf.jpg";